import { useQuery } from "@tanstack/react-query";
import React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { getUTLSettings } from "../../../repositorie/MESF-frontend-Repositorie";
import { TableSettings } from "./components/TableSettings";
import { Setting } from "./models/Setting";

export const searchSettings = () => {
	return useQuery<Setting[], Error>({
		queryKey: ["settings"],
		queryFn: ({ signal }) => getUTLSettings(signal),
	});
};

export const SettingsPage = () => {
	return (
		<>
			<HelmetDexteel title="Settings" />
			<TableSettings />
		</>
	);
};
